import { createSlice } from '@reduxjs/toolkit';
import { initStateGetCountryList, reducerGetCountryList } from '../actions/app/getCountryList';
import { initStateGetFilterGameList, reducerGetFilterGameList } from '../actions/app/getFilterGameList';
import { initStateGetTypePaymentList, reducerGetTypePaymentList } from '../actions/app/getTypePayment';
import { initStateClubList, reducerClubList } from '../actions/app/clubList';
import { initStateClubSingle, reducerClubSingle } from '../actions/app/clubSingle';
import { initStatePostList, reducerPostList } from '../actions/app/postList';
import { initStatePostSingle, reducerPostSingle } from '../actions/app/postSingle';
import { initStateProductList, reducerProductList } from '../actions/app/productList';
import { initStateProductSingle, reducerProductSingle } from '../actions/app/productSingle';
import { initStateDiscountList, reducerDiscountList } from '../actions/app/discountList';
import { initStateDiscountSingle, reducerDiscountSingle } from '../actions/app/discountSingle';
import { initStateCommentList, reducerCommentList } from '../actions/app/commentList';
import { initStateCommentSingle, reducerCommentSingle } from '../actions/app/commentSingle';
import { initStateLeagueList, reducerLeagueList } from '../actions/app/leagueList';
import { initStateUploadFile, reducerUploadFile } from '../actions/app/uploadFile';
import { initStateLeagueCreate, reducerLeagueCreate } from '../actions/app/leagueCreate';
import { initStateLeagueEdit, reducerLeagueEdit } from '../actions/app/leagueEdit';
import { initStateDeleteItem, reducerDeleteItem } from '../actions/app/deleteItem';
import { initStateUpdateClub, reducerUpdateClub } from '../actions/app/updateClub';
import { initStateCountryList, reducerCountryList } from '../actions/app/countryList';
import { initStateCountryEdit, reducerCountryEdit } from '../actions/app/countryEdit';
import { initStateCountryCreate, reducerCountryCreate } from '../actions/app/countryCreate';
import { initStateExerciseList, reducerExerciseList } from '../actions/app/exerciseList';
import { initStateExerciseSingle, reducerExerciseSingle } from '../actions/app/exerciseSingle';
import { initStateExerciseCreate, reducerExerciseCreate } from '../actions/app/exerciseCreate';
import { initStateExerciseEdit, reducerExerciseEdit } from '../actions/app/exerciseEdit';
import { initStateCityList, reducerCityList } from '../actions/app/cityList';
import { initStateCityCreate, reducerCityCreate } from '../actions/app/cityCreate';
import { initStateCityEdit, reducerCityEdit } from '../actions/app/cityEdit';
import { initStateCitySingle, reducerCitySingle } from '../actions/app/citySingle';

export const initialState = {
  ...initStateGetCountryList,
  ...initStateGetFilterGameList,
  ...initStateGetTypePaymentList,
  ...initStateClubList,
  ...initStateClubSingle,
  ...initStatePostList,
  ...initStatePostSingle,
  ...initStateProductList,
  ...initStateProductSingle,
  ...initStateDiscountList,
  ...initStateDiscountSingle,
  ...initStateCommentList,
  ...initStateCommentSingle,
  ...initStateLeagueList,
  ...initStateUploadFile,
  ...initStateLeagueCreate,
  ...initStateLeagueEdit,
  ...initStateDeleteItem,
  ...initStateUpdateClub,
  ...initStateCountryList,
  ...initStateCountryEdit,
  ...initStateCountryCreate,
  ...initStateExerciseList,
  ...initStateExerciseSingle,
  ...initStateExerciseCreate,
  ...initStateExerciseEdit,
  ...initStateCityList,
  ...initStateCityCreate,
  ...initStateCityEdit,
  ...initStateCitySingle,
  activeFilter: null,
  activePayment: null,
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setActiveFilter(state, action) {
      state.activeFilter = action.payload;
    },
    setActivePayment(state, action) {
      state.activePayment = action.payload;
    },
    resetClubList(state, action) {
      state.clubList = initStateClubList.clubList;
    },
    resetClubSingle(state, action) {
      state.clubSingle = initStateClubSingle.clubSingle;
    },
    resetPostList(state, action) {
      state.postList = initStatePostList.postList;
    },
    resetPostSingle(state, action) {
      state.postSingle = initStatePostSingle.postSingle;
    },
    resetProductList(state, action) {
      state.productList = initStateProductList.productList;
    },
    resetProductSingle(state, action) {
      state.productSingle = initStateProductSingle.productSingle;
    },
    resetDiscountList(state, action) {
      state.discountList = initStateDiscountList.discountList;
    },
    resetDiscountSingle(state, action) {
      state.discountSingle = initStateDiscountSingle.discountSingle;
    },
    resetCommentList(state, action) {
      state.commentList = initStateCommentList.commentList;
    },
    resetCommentSingle(state, action) {
      state.commentSingle = initStateCommentSingle.commentSingle;
    },
    resetLeagueList(state, action) {
      state.leagueList = initStateLeagueList.leagueList;
    },
    resetUploadFile(state, action) {
      state.uploadFile = initStateUploadFile.uploadFile;
    },
    resetLeagueCreate(state, action) {
      state.leagueCreate = initStateLeagueCreate.leagueCreate;
    },
    resetLeagueEdit(state, action) {
      state.leagueEdit = initStateLeagueEdit.leagueEdit;
    },
    resetDeleteItem(state, action) {
      state.deleteItem = initStateDeleteItem.deleteItem;
    },
    resetUpdateClub(state, action) {
      state.updateClub = initStateUpdateClub.updateClub;
    },
    resetCountryList(state, action) {
      state.countryList = initStateCountryList.countryList;
    },
    resetCountryEdit(state, action) {
      state.countryEdit = initStateCountryEdit.countryEdit;
    },
    resetCountryCreate(state, action) {
      state.countryCreate = initStateCountryCreate.countryCreate;
    },
    resetExerciseList(state, action) {
      state.exerciseList = initStateExerciseList.exerciseList;
    },
    resetExerciseSingle(state, action) {
      state.exerciseSingle = initStateExerciseSingle.exerciseSingle;
    },
    resetExerciseCreate(state, action) {
      state.exerciseCreate = initStateExerciseCreate.exerciseCreate;
    },
    resetExerciseEdit(state, action) {
      state.exerciseEdit = initStateExerciseEdit.exerciseEdit;
    },
    resetCityList(state, action) {
      state.cityList = initStateCityList.cityList;
    },
    resetCityCreate(state, action) {
      state.cityCreate = initStateCityCreate.cityCreate;
    },
    resetCitySingle(state, action) {
      state.citySingle = initStateCitySingle.citySingle;
    },
    resetCityEdit(state, action) {
      state.cityEdit = initStateCityEdit.cityEdit;
    },
  },
  extraReducers: {
    ...reducerCountryEdit,
    ...reducerGetCountryList,
    ...reducerGetFilterGameList,
    ...reducerGetTypePaymentList,
    ...reducerClubList,
    ...reducerClubSingle,
    ...reducerPostList,
    ...reducerPostSingle,
    ...reducerProductList,
    ...reducerProductSingle,
    ...reducerDiscountList,
    ...reducerDiscountSingle,
    ...reducerCommentList,
    ...reducerCommentSingle,
    ...reducerLeagueList,
    ...reducerUploadFile,
    ...reducerLeagueCreate,
    ...reducerLeagueEdit,
    ...reducerDeleteItem,
    ...reducerUpdateClub,
    ...reducerCountryList,
    ...reducerCountryCreate,
    ...reducerExerciseList,
    ...reducerExerciseSingle,
    ...reducerExerciseCreate,
    ...reducerExerciseEdit,
    ...reducerCityList,
    ...reducerCityCreate,
    ...reducerCitySingle,
    ...reducerCityEdit,
  },
});
export const {
  resetCitySingle,
  resetCityEdit,
  resetCityCreate,
  resetCityList,
  resetExerciseEdit,
  resetExerciseCreate,
  resetExerciseSingle,
  resetExerciseList,
  resetCountryCreate,
  resetCountryEdit,
  resetCountryList,
  resetUpdateClub,
  resetDeleteItem,
  resetLeagueEdit,
  resetLeagueCreate,
  resetUploadFile,
  resetLeagueList,
  resetCommentList,
  resetCommentSingle,
  resetDiscountList,
  resetDiscountSingle,
  resetProductSingle,
  resetProductList,
  resetPostSingle,
  resetClubSingle,
  resetClubList,
  setActiveFilter,
  setActivePayment,
} = appSlice.actions;
export const appReducer = appSlice.reducer;
